import { updateDialog, closeDialog } from '@Containers/Dialogs/DialogsActions';
import store from '@Store';
import { RESET_STATE, UPDATE_STATE_PARAMS, UPDATE_SETTINGS_PARAMS, INITIALIZE_DATA, typeOfSaveFormModal } from './SaveFormModalConstants';

export const updateStateParams = (params) => ({
  type: UPDATE_STATE_PARAMS,
  params,
});
export const initializeData = (payload, refreshForms) => ({
  type: INITIALIZE_DATA,
  payload,
  refreshForms,
});
export const openSaveFormModal = (props) => (dispatch) => {
  dispatch(
    updateDialog({
      id: typeOfSaveFormModal,
      dialogType: typeOfSaveFormModal,
      movable: false,
      backdrop: true,
      closeButton: false,
      className: 'save-from-modal-dialog-wrap',
      ...props,
    })
  );
  dispatch(initializeData(props.forms, props.refreshForms));
};
export const closeSaveFormModal = () => (dispatch) => {
  dispatch(
    closeDialog({
      id: typeOfSaveFormModal,
    })
  );
};
export const dispatchOpenSaveFormModal = (...args) => {
  store.dispatch(openSaveFormModal(...args));
};
export const dispatchCloseSaveFormModal = () => {
  store.dispatch(closeSaveFormModal());
};
export const updateSettingsParams = (params) => ({
  type: UPDATE_SETTINGS_PARAMS,
  params,
});
export const resetState = () => ({
  type: RESET_STATE,
});
